var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSegmentAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.9004 79.9005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ac4b869e-d514-4068-9149-3a47ab3e7ff3{fill:#52bd94;}.a3c0f6d5-9086-4c97-a1e1-942381521eec,.ac4b869e-d514-4068-9149-3a47ab3e7ff3{fill-rule:evenodd;}.a3c0f6d5-9086-4c97-a1e1-942381521eec,.b01b8b34-7ac2-456e-b678-dcdbe205ef41{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eaa5b143-4b71-4e3c-99a7-b287de4c90a0",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac4b869e-d514-4068-9149-3a47ab3e7ff3",
    d: "M79.9,39.95A39.95,39.95,0,1,1,39.95,0,39.95,39.95,0,0,1,79.9,39.95Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b01b8b34-7ac2-456e-b678-dcdbe205ef41",
    x: 35.2681,
    y: 32.5031,
    width: 24.538,
    height: 4.2566,
    rx: 0.7915
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b01b8b34-7ac2-456e-b678-dcdbe205ef41",
    x: 20.0854,
    y: 43.1408,
    width: 24.538,
    height: 4.2566,
    rx: 0.7915
  }), /*#__PURE__*/React.createElement("path", {
    className: "a3c0f6d5-9086-4c97-a1e1-942381521eec",
    d: "M23.0317,35.4169a.7978.7978,0,0,0,.964-.5421A16.7465,16.7465,0,0,1,43.564,23.6033a.7849.7849,0,0,0,.9193-.5708l.6926-2.5848a.7962.7962,0,0,0-.6019-.9805,21.0045,21.0045,0,0,0-24.6835,14.272.7878.7878,0,0,0,.5564.9852Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a3c0f6d5-9086-4c97-a1e1-942381521eec",
    d: "M56.8687,44.4835a.7979.7979,0,0,0-.964.5422A16.7465,16.7465,0,0,1,36.3364,56.2972a.7849.7849,0,0,0-.9193.5708l-.6926,2.5848a.7962.7962,0,0,0,.6019.98A21.0045,21.0045,0,0,0,60.01,46.1613a.7878.7878,0,0,0-.5564-.9852Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b01b8b34-7ac2-456e-b678-dcdbe205ef41",
    cx: 52.0787,
    cy: 25.4956,
    r: 2.3338
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b01b8b34-7ac2-456e-b678-dcdbe205ef41",
    cx: 27.8209,
    cy: 54.4049,
    r: 2.3338
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentAvatar);
export default __webpack_public_path__ + "static/media/segmentAvatar.d5eb219feb2bb5b4de087ccec9c2cb56.svg";
export { ForwardRef as ReactComponent };